import { useAuditorium } from '@/hooks/useAuditorium';
import { t } from 'i18next';
import React from 'react';
import { FiSend } from 'react-icons/fi';
import { ChatFooter, ChatForm, ChatOriginalText } from '@/components/custom/chat/chat';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export function AuditoriumViewCommentForm(props) {
  const { messageIds, setMessageIds } = useAuditorium();
  const { commentForm } = props;
  let reply = messageIds ? true : false;

  const handleSubmit = e => {
    e.preventDefault();
    commentForm.handleSubmit();

    if (commentForm.values.body) {
      setTimeout(() => {
        commentForm.setFieldValue('body', '');
        setMessageIds(null);
      }, 200);
    }
  };

  const extractTextFromHTML = html => {
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || '';
  };

  return (
    <ChatFooter variant={reply ? 'reply' : 'default'}>
      {reply && messageIds ? <ChatOriginalText dangerouslySetInnerHTML={{ __html: messageIds.messageBody.length > 30 ? `${extractTextFromHTML(messageIds.messageBody).substring(0, 60)}...` : messageIds.messageBody }}></ChatOriginalText> : null}

      <ChatForm onSubmit={handleSubmit}>
        <Input
          type="text"
          name="body"
          id="body"
          placeholder={t('activity.placeholderWriteComment')}
          aria-label={t('activity.placeholderWriteComment')}
          value={commentForm.values.body}
          onChange={commentForm.handleChange}
        />
        <Button
          size="icon"
          type="submit"
          className="shrink-0"
        >
          <FiSend />
        </Button>
      </ChatForm>
    </ChatFooter>
  );
}
